import { UIText3 } from '@cian/ui-kit';
import { More16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardMenuControlProps = {
  onClick(): void;
};

export const UserCardMenuControl: React.VFC<TUserCardMenuControlProps> = ({ onClick }) => {
  return (
    <button type="button" onClick={onClick} className={styles['button']} data-testid="UserCardMenuControl">
      <More16 color="primary_100" height={24} />
      <UIText3 color="primary_100">Еще</UIText3>
    </button>
  );
};
